import React, { useEffect, useState, useContext} from "react";
import { getProductsByMachine } from "../api";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext"
/**
 * Selector de productos por máquina (opcional).
 * Props:
 * - id_c: string (requerido)
 * - cod_maq: string (máquina seleccionada). Si no hay, el select se deshabilita.
 * - value: string (id_prod seleccionado) - controlado
 * - onSelect: function(newValue) -> void
 * - placeholder: string (default "— Sin producto —")
 * - className: string (clases extra)
 */
const ProdListByMachineBut = ({
  id_c,
  cod_maq,
  value,
  onSelect,
  placeholder = "— Sin producto —",
  className = ""
}) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  // Cuando cambia la máquina, limpiamos selección local
  useEffect(() => {
    if (onSelect) onSelect(""); // reset producto al cambiar máquina
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cod_maq]);

  useEffect(() => {
    let alive = true;
    const load = async () => {
      if (!id_c || !cod_maq) {
        setItems([]);
        return;
      }
      setLoading(true);
      try {
        const data = await getProductsByMachine(id_c, cod_maq); // { products: [...] }
        if (!alive) return;
        setItems(Array.isArray(data?.products) ? data.products : []);
      } catch (e) {
        console.error("❌ Error loading products by machine:", e);
        if (alive) setItems([]);
      } finally {
        if (alive) setLoading(false);
      }
    };
    load();
    return () => { alive = false; };
  }, [id_c, cod_maq]);

  const disabled = !cod_maq || loading;

  return (
    <select
      className={`input1 ${className}`}
      value={value || ""}
      onChange={(e) => onSelect && onSelect(e.target.value)}
      disabled={disabled}
    >
      <option value="">{loading ? "Cargando..." : placeholder}</option>
      {!loading && items.map((p) => (
        <option key={`${p.id_prod}-${p.cod_maq || "x"}`} value={p.id_prod}>
          {p.id_prod}{p.name_prod ? ` — ${p.name_prod}` : ""}
        </option>
      ))}
    </select>
  );
};

export default ProdListByMachineBut;
